import styled from 'styled-components';
import { Text } from '@lmn/design-system';
import { useHotelPromotion } from '@/app/components/hotel-detail/hooks/useFetchHotelPromotions';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import customCss from './css/customCss';

const LmnDealsExtrasContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  @media ${customCss.breakpoints.sm} {
    gap: 4px;
    max-width: 900px;
  }
`;

export const LmnDealsExtrasRow = styled.div`
  display: flex;
  gap: 8px;
  padding: 2px 0;
  align-items: flex-start;
`;

interface LmnDealsExtrasProps {
  extras?: string[];
}

export default function LmnDealsExtras({ extras = [] }: LmnDealsExtrasProps) {
  const { showLmnDealsPromotion } = useHotelPromotion();
  const { localization } = usePageWrapperData();
  const { imageBasePath } = localization;

  if (!extras || extras.length === 0) {
    return null;
  }

  return (
    <LmnDealsExtrasContainer>
      {extras.map((extra, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <LmnDealsExtrasRow key={`extra.${index}`}>
          {}
          <img
            src={`${imageBasePath}icons/${showLmnDealsPromotion ? 'last_minute_deals_rebrand_extra_check' : 'flash_sales_extra_check'}.svg`}
            width={20}
            height={20}
            alt="included"
          />
          <Text variant="BodySmall">{extra}</Text>
        </LmnDealsExtrasRow>
      ))}
    </LmnDealsExtrasContainer>
  );
}
